import { render, staticRenderFns } from "./PdpBuildABundleCta.vue?vue&type=template&id=1e923902&scoped=true&"
import script from "./PdpBuildABundleCta.vue?vue&type=script&lang=js&"
export * from "./PdpBuildABundleCta.vue?vue&type=script&lang=js&"
import style0 from "./PdpBuildABundleCta.vue?vue&type=style&index=0&id=1e923902&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e923902",
  null
  
)

export default component.exports